import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import DashboardCard from './DashboardCard';
import { STATUS, formatTry } from '../constants';
import { Footnote } from '../styles';

export default function SixMonthTrendCard({ slice }) {
  const { t, i18n } = useTranslation();
  const data = slice.data;

  const model = useMemo(() => {
    if (!data) return [];
    const byMonth = new Map();
    (data.monthlyMatrix || []).forEach((r) => {
      byMonth.set(r.monthStart, (byMonth.get(r.monthStart) || 0) + r.total);
    });
    return [...byMonth.entries()]
      .sort(([a], [b]) => (a < b ? -1 : 1))
      .map(([month, total]) => ({
        label: new Date(month).toLocaleDateString(i18n.language, { month: 'short' }),
        value: Math.round(total),
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, i18n.language]);

  return (
    <DashboardCard
      cardKey="son-6-ay-trend"
      title={t('expenseDashboard.trend.title')}
      meta={t('expenseDashboard.trend.meta')}
      span={8}
      spanMd={6}
      loading={slice.loading}
      empty={model.length === 0 || model.every((m) => m.value === 0)}
      emptyText={t('expenseDashboard.trend.empty')}
    >
      <div>
        <ResponsiveContainer width="100%" height={170}>
          <BarChart data={model} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
            <XAxis
              dataKey="label"
              tickLine={false}
              axisLine={{ stroke: '#E1E0D9' }}
              tick={{ fontSize: 10, fill: '#898781' }}
            />
            <YAxis hide />
            <Tooltip
              cursor={{ fill: 'rgba(2, 145, 239, 0.05)' }}
              formatter={(value) => [formatTry(value), null]}
            />
            <Bar dataKey="value" barSize={22} radius={[4, 4, 0, 0]} fill={STATUS.normal} />
          </BarChart>
        </ResponsiveContainer>
        <Footnote>{t('expenseDashboard.trend.note')}</Footnote>
      </div>
    </DashboardCard>
  );
}
